import { styled } from '@mui/material/styles';
import { TypographyProps } from '@mui/material';


interface SunnysideBulletPointProps extends TypographyProps {
    children: any,
    fontVariant?: string
}

export default function SunnysideBulletPoint(props: SunnysideBulletPointProps): JSX.Element {
    const { children, fontVariant } = props;
    const StyledListItem = styled('li')(({ theme }) => ({
        fontFamily: 'Good Sans Light',
        fontWeight: theme.typography[fontVariant || 'terms_body'].fontWeight,
        fontStyle: theme.typography[fontVariant || 'terms_body'].fontStyle,
        letterSpacing: theme.typography[fontVariant || 'terms_body'].letterSpacing,
        color: theme.typography[fontVariant || 'terms_body'].color,
        fontSize: theme.typography.blog[theme.breakpoints.down('sm')].fontSize,
        lineHeight: theme.typography[fontVariant || 'terms_body'].lineHeight,
        paddingBottom: '1rem',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography[fontVariant || 'terms_body'][theme.breakpoints.down('sm')].fontSize,
            lineHeight: theme.typography[fontVariant || 'terms_body'][theme.breakpoints.down('sm')].lineHeight,
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: theme.typography[fontVariant || 'terms_body'][theme.breakpoints.up('sm')].fontSize,
            lineHeight: theme.typography[fontVariant || 'terms_body'][theme.breakpoints.up('sm')].lineHeight,
        },
    }));
    return (
        <StyledListItem>
            {children}
        </StyledListItem>
    );
}